import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useEffect, useMemo, useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { isValidArray, mapMstBranchToOptions, mapMstToOptions } from "utils/HelperFunction";
import { getAllMstBranch } from "../../redux/handlers/master/getAllMstBranch.handler";
import { initStateReportProductDoData } from "mocks/reportProductDoData";
import useReportProductDoModalInit from "./useReportProductDoModalInit";
import { getAllMstVat } from "../../redux/handlers/master/getAllMstVat.handler";
import * as yup from "yup";
import { useFormReportProductDo } from "./useFormReportProductDo";
import { getUserInfo } from "../../redux/handlers/auth/getUserInfo.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
export var useInitReportProductDo = function() {
    var schema = yup.object().shape({
        dimBranchIDList: yup.array().of(yup.number().required()).min(1, "กรุณาเลือกสาขาอย่างน้อย 1 รายการ").required("กรุณาเลือกสาขา")
    });
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(initStateReportProductDoData), 2), formData = _useState[0], setFormData = _useState[1];
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState1 = _sliced_to_array(useState([]), 2), tableData = _useState1[0], setTableData = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), branchMultiSelected = _useState2[0], setBranchMultiSelected = _useState2[1];
    var _useState3 = _sliced_to_array(useState({
        startDate: new Date(),
        endDate: new Date()
    }), 2), reportDate = _useState3[0], setReportDate = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), userInfo = _useState4[0], setUserInfo = _useState4[1];
    var modalReportProductDoState = useReportProductDoModalInit();
    var formReportProductDoState = useFormReportProductDo({
        tableData: tableData,
        setTableData: setTableData
    });
    // Reducers
    var reducers = {
        vat: useAppSelector(function(state) {
            return state.getAllMstVatReducer;
        }),
        branch: useAppSelector(function(state) {
            return state.getAllMstBranchReducer;
        }),
        userInfo: useAppSelector(function(state) {
            return state.getUserInfoReducer;
        })
    };
    // Derived options using useMemo for performance
    var options = useMemo(function() {
        var _reducers_vat_data, _reducers_branch_data, _reducers_vat_data_data, _reducers_vat_data1, _reducers_branch_data1;
        var optionsInit = {
            vat: [],
            branch: []
        };
        var isReady = isValidArray((_reducers_vat_data = reducers.vat.data) === null || _reducers_vat_data === void 0 ? void 0 : _reducers_vat_data.data) && isValidArray((_reducers_branch_data = reducers.branch.data) === null || _reducers_branch_data === void 0 ? void 0 : _reducers_branch_data.data);
        if (!isReady) return optionsInit;
        return {
            vat: (_reducers_vat_data1 = reducers.vat.data) === null || _reducers_vat_data1 === void 0 ? void 0 : (_reducers_vat_data_data = _reducers_vat_data1.data) === null || _reducers_vat_data_data === void 0 ? void 0 : _reducers_vat_data_data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id,
                    vat: item.value
                };
            }),
            branch: mapMstBranchToOptions(((_reducers_branch_data1 = reducers.branch.data) === null || _reducers_branch_data1 === void 0 ? void 0 : _reducers_branch_data1.data) || [])
        };
    }, [
        reducers.vat.data,
        reducers.branch.data
    ]);
    var isInitReportProductDoLoading = useMemo(function() {
        return reducers.vat.isFetching || reducers.branch.isFetching || reducers.userInfo.isFetching;
    }, [
        reducers.vat.isFetching,
        reducers.branch.isFetching,
        reducers.userInfo.isFetching
    ]);
    // Load master data
    var loadMstData = useCallback(function() {
        dispatch(getAllMstVat());
        dispatch(getAllMstBranch());
    }, []);
    var loadResources = useCallback(function() {
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        if (reducers.userInfo.data && reducers.userInfo.data !== userInfo) {
            setUserInfo(reducers.userInfo.data.data);
        }
    }, [
        reducers.userInfo.data
    ]);
    // Auto-load
    useEffect(function() {
        loadMstData();
        loadResources();
    }, [
        loadMstData,
        loadResources
    ]);
    // useEffect(() => {
    //   setIsLoading(isInitReportProductDoLoading);
    // }, [isInitReportProductDoLoading]);
    return {
        isInitReportProductDoLoading: isInitReportProductDoLoading,
        formData: formData,
        setFormData: setFormData,
        options: options,
        modalReportProductDoState: modalReportProductDoState,
        branchMultiSelected: branchMultiSelected,
        setBranchMultiSelected: setBranchMultiSelected,
        schema: schema,
        formReportProductDoState: formReportProductDoState,
        tableData: tableData,
        setTableData: setTableData,
        userInfo: userInfo,
        reportDate: reportDate,
        setReportDate: setReportDate
    };
};
